import { render, staticRenderFns } from "./team_awards.vue?vue&type=template&id=073c8fca&scoped=true&"
import script from "./team_awards.vue?vue&type=script&lang=js&"
export * from "./team_awards.vue?vue&type=script&lang=js&"
import style0 from "./team_awards.vue?vue&type=style&index=0&id=073c8fca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073c8fca",
  null
  
)

export default component.exports